import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { handleRedirectToLanguageRoute } from '../utils/language-route-redirect';
import { getItem } from '../helper/localstorage.helper';

// Custom hook for handling signin success
export const useSigninSuccess = (isSuccess: boolean, user: any) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        if (isSuccess && user) {
            toast.success(t("Logged in successfully") as string);
        }
    }, [isSuccess, user, navigate, t]);
};

// Custom hook for handling signin errors
export const useSigninError = (submitError: string | null) => {
    const { t } = useTranslation();

    useEffect(() => {
        if (submitError) {
            toast.error(t(submitError) as string);
        }
    }, [submitError, t]);
};
